import { render } from "./createTask.html?vue&type=template&id=f4316362&scoped=true&ts=true&external"
import script from "./CreateTask.vue?vue&type=script&lang=ts"
export * from "./CreateTask.vue?vue&type=script&lang=ts"

import "./CreateTask.vue?vue&type=style&index=0&id=f4316362&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4316362"]])

export default __exports__